"use client"

import { CheckCircle2, Download, X } from "lucide-react"
import { Button } from "../../components/ui/button"
import { Card } from "../../components/ui/card"

interface QuoteConfirmationProps {
  onClose?: () => void
  onDownloadPDF?: () => void
  quoteNumber?: string
  customerName?: string
  customerPhone?: string
  customerEmail?: string
  customerCity?: string
  customerDesc?: string
}

export function QuoteConfirmation({
  onClose,
  onDownloadPDF,
  quoteNumber = "2024-001",
  customerName = "Cliente",
}: QuoteConfirmationProps) {
  const handleDownload = () => {
    if (onDownloadPDF) {
      onDownloadPDF()
    } else {
      // Implementação padrão de download
    }
  }

  const closeQuote = function () {
    document.body.style.display = "none";
    alert("Envie a menssagem do whatssapp da loja e aguarde contato!")
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
      <Card className="relative w-full max-w-lg animate-in fade-in zoom-in duration-300">
        <button
          onClick={() => {
            closeQuote()
          }}
          className="absolute right-4 top-4 rounded-full p-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
          aria-label="Fechar"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center gap-6 p-8 text-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-accent/10" id="eee">
            <CheckCircle2 className="h-12 w-12 text-accent" />
          </div>

          <div className="space-y-3">
            <h2 className="text-balance text-3xl font-bold tracking-tight text-foreground">
              Orçamento Enviado com Sucesso!
            </h2>
            <p className="text-pretty text-base leading-relaxed text-muted-foreground">
              Obrigado pelo seu contato, <span className="font-semibold text-foreground">#{customerName}</span>! Recebemos sua solicitação de orçamento{" "}
              <span className="font-semibold text-foreground">#{quoteNumber}</span> e nossa equipe entrará em contato em
              breve.
            </p>
          </div>

          <div className="w-full space-y-4 rounded-lg bg-secondary/50 p-6">
            <div className="space-y-2 text-sm">
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Número do Orçamento:</span>
                <span className="font-semibold text-foreground">#{quoteNumber}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Tempo de Resposta:</span>
                <span className="font-semibold text-foreground">24-48 horas</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Status:</span>
                <span id="ddd" className="inline-flex items-center gap-1.5 rounded-full bg-accent/10 px-3 py-1 text-xs font-medium text-accent">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent " />
                  Em Análise
                </span>
              </div>
            </div>
          </div>

          {/**<p className="text-pretty text-sm text-muted-foreground">
            Enviamos uma cópia do seu orçamento para o seu e-mail. Você também pode baixar o PDF para seus registros.
          </p> */}

          <div className="flex w-full flex-col gap-3 sm:flex-row">
            {/**<Button
            id="qqq"
              onClick={handleDownload}
              className="flex-1 gap-2 bg-accent text-accent-foreground hover:bg-accent/90"
              size="lg"
            >
              <Download className="h-4 w-4" />
              Baixar PDF
            </Button> */}
            <Button onClick={() => {
              closeQuote()
            }} variant="outline" className="flex-1 bg-transparent" size="lg">
              Fechar
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}